import React from 'react';
import { Container, Typography, Box, Grid, Paper } from '@mui/material';
import { Email, LocationOn, Phone, AccessTime } from '@mui/icons-material';

const ContactUs = () => {

  const contactDetails = [
    {
      icon: <LocationOn color="primary" />,
      title: "Our Office",
      content: (
        <Typography variant="body1">
          Building No./Flat No.: 14-300/36/A/1,<br />
          Road/Street: Bollaramm Village Road<br />
          City/Town/Village: Hyderabad<br />
          District: Sangareddy, Telangana - 502325
        </Typography>
      )
    },
    {
      icon: <Email color="primary" />,
      title: "Email Us",
      content: (
        <Typography variant="body1">
          support@thathvauniforms.com
        </Typography>
      )
    },
    // {
    //   icon: <Phone color="primary" />,
    //   title: "Call Us",
    //   content: (
    //     <Typography variant="body1">
    //       +91 90100 38559<br />
    //       Available Mon-Sat
    //     </Typography>
    //   )
    // },
    {
      icon: <AccessTime color="primary" />,
      title: "Business Hours",
      content: (
        <Typography variant="body1">
          Monday - Friday: 9:00 AM - 5:00 PM<br />
          Saturday: 10:00 AM - 4:00 PM<br />
          Sunday: Closed
        </Typography>
      )
    }
  ];

  return (
    <Box sx={{ bgcolor: '#f4f7f9', minHeight: '100vh' }}>
      {/* Header */}
      <Box sx={{ bgcolor: 'primary.dark', color: 'white', py: 8, textAlign: 'center' }}>
        <Container maxWidth="md">
          <Typography variant="h2" component="h1" gutterBottom fontWeight="bold">
            Get In Touch
          </Typography>
          <Typography variant="h6" sx={{ opacity: 0.8 }}>
            Have questions about sizes, orders, or delivery? We're here to help.
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ py: 10, mt: -5 }}>
        {/* <Grid container spacing={4}> */}

          {/* Contact Info */}
          <Grid item xs={2} md={5}>
            <Grid container spacing={4}>
              {contactDetails.map((detail, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Paper
                    elevation={2}
                    sx={{
                      p: 3,
                      borderRadius: 3,
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 2,
                      height: '100%',
                    }}
                  >
                    <Box
                      sx={{
                        bgcolor: 'rgba(13, 110, 253, 0.1)',
                        p: 1.5,
                        borderRadius: 2,
                        display: 'flex',
                      }}
                    >
                      {detail.icon}
                    </Box>

                    <Box>
                      <Typography variant="h6" fontWeight="bold" gutterBottom>
                        {detail.title}
                      </Typography>
                      {detail.content}
                    </Box>
                  </Paper>
                </Grid>
              ))}
            </Grid>

            {/* Map Placeholder or Additional Info */}
            <Box sx={{ mt: 4, p: 1 }}>
              <Typography variant="h6" gutterBottom fontWeight="bold">
                Visit Our Factory
              </Typography>
              <Typography variant="body2" color="text.secondary">
                For bulk inquiries or custom requirements, you can visit our production facility in Hyderabad with a prior appointment.
              </Typography>
            </Box>
          </Grid>
        {/* </Grid> */}
      </Container>
    </Box>
  );
};

export default ContactUs;
